var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingsAddCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9995 41.9993C35.9995 40.8948 36.8949 39.9993 37.9995 39.9993H45.9995C47.1041 39.9993 47.9995 40.8948 47.9995 41.9993C47.9995 43.1039 47.1041 43.9993 45.9995 43.9993H37.9995C36.8949 43.9993 35.9995 43.1039 35.9995 41.9993Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9995 49.9993C35.9995 48.8948 36.8949 47.9993 37.9995 47.9993H49.9995C51.1041 47.9993 51.9995 48.8948 51.9995 49.9993C51.9995 51.1039 51.1041 51.9993 49.9995 51.9993H37.9995C36.8949 51.9993 35.9995 51.1039 35.9995 49.9993Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99951 25.9993C7.99951 20.4758 12.4795 15.9993 18.0016 15.9993H61.9974C67.5195 15.9993 71.9995 20.4758 71.9995 25.9993V28.9993C71.9995 31.2085 70.2086 32.9993 67.9995 32.9993H17.9995C16.8949 32.9993 15.9995 32.1039 15.9995 30.9993C15.9995 29.8948 16.8949 28.9993 17.9995 28.9993H67.9995V25.9993C67.9995 22.6863 65.3118 19.9993 61.9974 19.9993H18.0016C14.6872 19.9993 11.9995 22.6863 11.9995 25.9993V53.9993C11.9995 57.313 14.6858 59.9993 17.9995 59.9993H61.9995C65.3132 59.9993 67.9995 57.313 67.9995 53.9993V38.9993C67.9995 37.8948 68.8949 36.9993 69.9995 36.9993C71.1041 36.9993 71.9995 37.8948 71.9995 38.9993V53.9993C71.9995 59.5222 67.5224 63.9993 61.9995 63.9993H17.9995C12.4767 63.9993 7.99951 59.5222 7.99951 53.9993V25.9993Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9995 44.9993C25.1041 44.9993 25.9995 44.1039 25.9995 42.9993C25.9995 41.8948 25.1041 40.9993 23.9995 40.9993C22.8949 40.9993 21.9995 41.8948 21.9995 42.9993C21.9995 44.1039 22.8949 44.9993 23.9995 44.9993ZM23.9995 48.9993C27.3132 48.9993 29.9995 46.313 29.9995 42.9993C29.9995 39.6856 27.3132 36.9993 23.9995 36.9993C20.6858 36.9993 17.9995 39.6856 17.9995 42.9993C17.9995 46.313 20.6858 48.9993 23.9995 48.9993Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9994 50.9993C25.9607 50.9993 27.6474 52.4261 28.0378 54.3894C28.2532 55.4727 29.3061 56.1763 30.3895 55.9609C31.4728 55.7455 32.1764 54.6926 31.961 53.6093C31.2169 49.867 27.9621 46.9993 23.9994 46.9993C20.0367 46.9993 16.782 49.867 16.0378 53.6093C15.8224 54.6926 16.526 55.7455 17.6093 55.9609C18.6927 56.1763 19.7456 55.4727 19.961 54.3894C20.3514 52.4261 22.0381 50.9993 23.9994 50.9993Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsAddCard);
export default __webpack_public_path__ + "static/media/iconSettingsAddCard.a58ecd50de3e8fecbc0723da401e8c43.svg";
export { ForwardRef as ReactComponent };